
export const CREATE_PROJECT_START = 'CREATE_PROJECT_START';
export const CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS';
export const CREATE_PROJECT_ERROR = 'CREATE_PROJECT_ERROR';
export const CREATE_PROJECT_RESET = 'CREATE_PROJECT_RESET';

export const GET_PROJECT_FILES_START = 'GET_PROJECT_FILES_START';
export const GET_PROJECT_FILES_SUCCESS = 'GET_PROJECT_FILES_SUCCESS';
export const GET_PROJECT_FILES_ERROR = 'GET_PROJECT_FILES_ERROR';

export const CREATE_TASK_START = 'CREATE_TASK_START';
export const CREATE_TASK_SUCCESS = 'CREATE_TASK_SUCCESS';
export const CREATE_TASK_ERROR = 'CREATE_TASK_ERROR';
export const CREATE_TASK_RESET = 'CREATE_TASK_RESET';

export const GET_TASK_FILES_START = 'GET_TASK_FILES_START';
export const GET_TASK_FILES_SUCCESS = 'GET_TASK_FILES_SUCCESS';
export const GET_TASK_FILES_ERROR = 'GET_TASK_FILES_ERROR';

export const CREATE_NAVIGATION_START = 'CREATE_NAVIGATION_START';
export const CREATE_NAVIGATION_SUCCESS = 'CREATE_NAVIGATION_SUCCESS';
export const CREATE_NAVIGATION_ERROR = 'CREATE_NAVIGATION_ERROR';
export const CREATE_NAVIGATION_RESET = 'CREATE_NAVIGATION_RESET';


export const CREATE_FORM_START = 'CREATE_FORM_START';
export const CREATE_FORM_SUCCESS = 'CREATE_FORM_SUCCESS';
export const CREATE_FORM_ERROR = 'CREATE_FORM_ERROR';
export const CREATE_FORM_RESET = 'CREATE_FORM_RESET';

export const GET_FORM_START = 'GET_FORM_START';
export const GET_FORM_SUCCESS = 'GET_FORM_SUCCESS';
export const GET_FORM_ERROR = 'GET_FORM_ERROR';

export const SAVE_FORM_START = 'SAVE_FORM_START';
export const SAVE_FORM_SUCCESS = 'SAVE_FORM_SUCCESS';
export const SAVE_FORM_ERROR = 'SAVE_FORM_ERROR';
export const SAVE_FORM_RESET = 'SAVE_FORM_RESET';


export const SIGNUP_START = 'SIGNUP_START';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_ERROR = 'SIGNUP_ERROR';
export const SIGNUP_RESET = 'SIGNUP_RESET';


export const CREATE_USER_START = 'CREATE_USER_START';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_ERROR = 'CREATE_USER_ERROR';
export const CREATE_USER_RESET = 'CREATE_USER_RESET';

export const GET_LIST_START = 'GET_LIST_START';
export const GET_LIST_SUCCESS = 'GET_LIST_SUCCESS';
export const GET_LIST_ERROR = 'GET_LIST_ERROR';

export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGIN_RESET = 'LOGIN_RESET';




